import { ChargerExcludeInputModel } from "@/models/chargerExclude";

export const ChargerExcludeConstants = {
  ChargerExclude: "充電器利用一時停止",
  InstallationLoationOfficeName: "設置場所（会社／営業所）",
  ChargerName: "充電器名",
  SuspensionOfUseStartDate: "利用一時停止開始日時",
  Reason: "理由",
  ChargerExcludeNewRegistration: "充電器利用一時停止新規登録",
  ChargerExcludeDetails: "充電器利用一時停止詳細",
  ChargerExcludeEdit: "充電器利用一時停止編集",
  BasicInfomation: "基本情報",
  ChargerModelName: "充電器機種名",
  InstallationLocation: "設置場所",
  SaleOffices: "（会社／営業所）",
} as const;

export const inputDefault: ChargerExcludeInputModel = {
  officeId: undefined,
  chargerId: undefined,
  startAt: "",
  cause: "",
};
